// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgDishwasherIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m4 15s0 1-1 1H7c-1 0-1-1-1-1l2-1v-3s-2-1-2-2 1-4 1-4h3s1 3 1 4-2 2-2 2v3zM10 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m5 14c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m2.97-5.66A3.95 3.95 0 0 0 15 13c-1.19 0-2.23.52-2.97 1.34-.01-.11-.03-.22-.03-.34 0-1.66 1.34-3 3-3s3 1.34 3 3c0 .12-.02.23-.03.34m0-3A3.95 3.95 0 0 0 15 10c-1.19 0-2.23.52-2.97 1.34-.01-.11-.03-.22-.03-.34 0-1.66 1.34-3 3-3s3 1.34 3 3c0 .12-.02.23-.03.34" />
  </g>
);
export default SvgDishwasherIcon;
SvgDishwasherIcon.displayName = 'SvgDishwasherIcon';
